import DadosClienteTab from "./DadosClienteTab";
import { useDispatch, useSelector } from "react-redux";
import { getDetalhesCliente, getDominiosCliente } from "../../selectors/clientes.selectors";
import {
  actions as routeActions,
  types as routes,
} from "../../actions/rotas.actions";
import { useCallback } from "react";

const DadosClienteTabConnected = () => {
  const data = useSelector(getDetalhesCliente);
  const dominios = useSelector(getDominiosCliente);
  const dispatch = useDispatch();

  const handleEditar = useCallback(() => {
    dispatch(
      routeActions.redirectTo(routes.PREENCHIMENTO_CLIENTE, { id: data.id })
    );
  }, [dispatch, data]);

  return (
    <DadosClienteTab
      data={data}
      dominios={dominios}
      handleEditar={handleEditar}
    />
  );
};

export default DadosClienteTabConnected;
